import { render, staticRenderFns } from "./response-error-alert.vue?vue&type=template&id=5288c244&scoped=true&"
import script from "./response-error-alert.vue?vue&type=script&lang=js&"
export * from "./response-error-alert.vue?vue&type=script&lang=js&"
import style0 from "./response-error-alert.vue?vue&type=style&index=0&id=5288c244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5288c244",
  null
  
)

export default component.exports